<svg
  ><defs
    ><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath><filter
      id="a"
      width="125%"
      height="125%"
      x="-12.5%"
      y="-12.5%"
      filterUnits="objectBoundingBox"
      ><feOffset in="SourceAlpha" result="shadowOffsetOuter1" /><feGaussianBlur
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
        stdDeviation="2"
      /><feColorMatrix
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
        values="0 0 0 0 0.126438483 0 0 0 0 0.127406141 0 0 0 0 0.129341457 0 0 0 1 0"
      /><feMerge><feMergeNode in="shadowMatrixOuter1" /><feMergeNode in="SourceGraphic" /></feMerge
      ></filter
    ><style>
      .cls-1 {
        isolation: isolate;
      }
      .cls-2 {
        fill: #242727;
      }
    </style><pattern
      id="a"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 120 120"
      ><image
        xlink:href="data:image/png;base64,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"
        width="120"
        height="120"
      /></pattern
    ></defs
  ><symbol id="add-circle-line" viewBox="0 0 24 24"
    ><path
      d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
    /></symbol
  ><symbol id="add-line" viewBox="0 0 24 24"><path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" /></symbol
  ><symbol id="add" viewBox="0 0 40 40"
    ><path d="M19 0h2v40h-2z" /><path d="M0 19h40v2H0z" /></symbol
  ><symbol id="alert-fill" viewBox="0 0 24 24"
    ><path
      d="m12.866 3 9.526 16.5a1 1 0 0 1-.866 1.5H2.474a1 1 0 0 1-.866-1.5L11.134 3a1 1 0 0 1 1.732 0M11 16v2h2v-2zm0-7v5h2V9z"
    /></symbol
  ><symbol id="alert-line" viewBox="0 0 24 24"
    ><path
      d="m12.866 3 9.526 16.5a1 1 0 0 1-.866 1.5H2.474a1 1 0 0 1-.866-1.5L11.134 3a1 1 0 0 1 1.732 0m-8.66 16h15.588L12 5.5zM11 16h2v2h-2zm0-7h2v5h-2z"
    /></symbol
  ><symbol id="arrow-classic" viewBox="0 0 24 24"
    ><path fill="none" d="M24 0v24H0V0Z" /><path
      fill="currentColor"
      d="M13 21V6.83l3.59 3.58L18 9l-6-6-6 6 1.41 1.41L11 6.83V21Z"
    /></symbol
  ><symbol id="arrow-down-line" viewBox="0 0 24 24"
    ><path
      d="m13 16.172 5.364-5.364 1.414 1.414L12 20l-7.778-7.778 1.414-1.414L11 16.172V4h2z"
    /></symbol
  ><symbol id="arrow-down" viewBox="0 0 11.314 6.364"
    ><path d="M0 .707.707 0l5.657 5.657-.708.707z" /><path
      d="M4.95 5.657 10.605 0l.707.707-5.657 5.657z"
    /></symbol
  ><symbol id="arrow-in" viewBox="0 0 11.314 19.798"
    ><path fill="currentColor" d="m0 18.384 8.486-8.485L0 1.414 1.414 0l9.9 9.9-9.9 9.9Z" /></symbol
  ><symbol id="arrow-left-right-line" viewBox="0 0 24 24"
    ><path
      d="M16.05 12.05 21 17l-4.95 4.95-1.414-1.415L17.172 18H4v-2h13.172l-2.536-2.535zm-8.1-10 1.414 1.414-2.536 2.535H20v2H6.828l2.536 2.536L7.95 11.95 3 7z"
    /></symbol
  ><symbol id="arrow-left-s-line" viewBox="0 0 24 24"
    ><path d="m10.828 12 4.95 4.95-1.414 1.415L8 12l6.364-6.364 1.414 1.414z" /></symbol
  ><symbol id="arrow-right-s-line" viewBox="0 0 24 24"
    ><path d="m13.172 12-4.95-4.95 1.414-1.413L16 12l-6.364 6.364-1.414-1.415z" /></symbol
  ><symbol id="arrow-right-up-long-line" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="m5.636 19.778-1.414-1.414L15.657 6.93h-5.586v-2h9v9h-2V8.343z"
    /></symbol
  ><symbol id="arrow-right" viewBox="0 0 15.072 14.141"
    ><path
      fill="currentColor"
      d="m7.3 13.435 5.863-5.865H0v-1h13.159L7.3.706 8 0l7.071 7.071L8 14.141Z"
    /></symbol
  ><symbol id="arrow-up-line" viewBox="0 0 24 24"
    ><path
      d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414z"
    /></symbol
  ><symbol id="article-handle" viewBox="0 0 22 22"
    ><g fill="#3b4d6a" transform="translate(-494.5 -471)"
      ><circle cx="2" cy="2" r="2" transform="translate(507 474)" /><circle
        cx="2"
        cy="2"
        r="2"
        transform="translate(507 480)"
      /><circle cx="2" cy="2" r="2" transform="translate(507 486)" /><circle
        cx="2"
        cy="2"
        r="2"
        transform="translate(500 474)"
      /><circle cx="2" cy="2" r="2" transform="translate(500 480)" /><circle
        cx="2"
        cy="2"
        r="2"
        transform="translate(500 486)"
      /></g
    ></symbol
  ><symbol id="article-main-plus" viewBox="0 0 32 32"
    ><path
      fill="#3b4d6a"
      d="M15.999 31.999A15.9 15.9 0 0 1 9.98 30.83a16 16 0 0 1-1.71-.813l1.232-2.235a13 13 0 0 0 1.418.676 13.5 13.5 0 0 0 5.058.985 13.4 13.4 0 0 0 5.059-.986 13.4 13.4 0 0 0 4.448-2.954 13.3 13.3 0 0 0 2.95-4.445 13.4 13.4 0 0 0 .985-5.057 13.4 13.4 0 0 0-.985-5.058 13.4 13.4 0 0 0-2.952-4.445 13.4 13.4 0 0 0-4.447-2.952 13.4 13.4 0 0 0-5.057-.985 13.4 13.4 0 0 0-5.059.985 13.4 13.4 0 0 0-4.445 2.95 13.4 13.4 0 0 0-2.954 4.448 13.4 13.4 0 0 0-.983 5.058 13.4 13.4 0 0 0 .983 5.057 14 14 0 0 0 .688 1.444l-2.227 1.229a16 16 0 0 1-.813-1.71 15.9 15.9 0 0 1-1.171-6.021A15.9 15.9 0 0 1 1.169 9.98a15.9 15.9 0 0 1 3.513-5.292 15.9 15.9 0 0 1 5.294-3.515A15.9 15.9 0 0 1 15.997 0a16 16 0 0 1 6.021 1.173 15.9 15.9 0 0 1 5.292 3.515 15.9 15.9 0 0 1 3.517 5.294 16 16 0 0 1 1.171 6.019 16 16 0 0 1-1.173 6.021 15.9 15.9 0 0 1-3.515 5.292 15.9 15.9 0 0 1-5.292 3.515A15.9 15.9 0 0 1 16.01 32Zm-1.061-8.859v-6.08h-6.08a1.28 1.28 0 0 1-1.279-1.281A1.28 1.28 0 0 1 8.858 14.5h6.08V8.42a1.28 1.28 0 0 1 1.281-1.279 1.28 1.28 0 0 1 1.279 1.279v6.08h6.081a1.28 1.28 0 0 1 1.279 1.279 1.28 1.28 0 0 1-1.279 1.281h-6.081v6.08a1.28 1.28 0 0 1-1.279 1.279 1.28 1.28 0 0 1-1.286-1.279Z"
    /></symbol
  ><symbol id="article-plus" viewBox="0 0 22 22"
    ><g fill="#3b4d6a" transform="translate(-422 -471)"
      ><rect width="2" height="16" rx="1" transform="translate(432 474)" /><rect
        width="16"
        height="2"
        rx="1"
        transform="translate(425 481)"
      /></g
    ></symbol
  ><symbol id="basketball" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m.366 11.366-3.469 6.01a8.056 8.056 0 0 0 4.459.51 9.94 9.94 0 0 1 .784-5.494zm3.518 2.031a7.96 7.96 0 0 0-.587 3.894 8 8 0 0 0 3.078-2.456zm-7.025-4.055a9.95 9.95 0 0 1-4.365 3.428 8 8 0 0 0 2.671 3.605l3.469-6.009zm11.103-.13-.258.12a7.95 7.95 0 0 0-2.82 2.333l2.492 1.439a8 8 0 0 0 .586-3.893M4 12q0 .4.038.789a7.95 7.95 0 0 0 3.078-2.453L4.624 8.897A8 8 0 0 0 4 12m12.835-6.374-3.469 6.008 1.775 1.025a9.95 9.95 0 0 1 4.366-3.43 8 8 0 0 0-2.419-3.402zM12 4q-.695.001-1.357.115a9.93 9.93 0 0 1-.784 5.494l1.775 1.025 3.469-6.01A8 8 0 0 0 12 4m-3.297.71-.191.088a8 8 0 0 0-2.886 2.367l2.49 1.438a7.96 7.96 0 0 0 .587-3.893"
    /></symbol
  ><symbol id="bookmark-3-line" viewBox="0 0 24 24"
    ><path
      d="M4 2h16a1 1 0 0 1 1 1v19.276a.5.5 0 0 1-.704.457L12 19.03l-8.296 3.702A.5.5 0 0 1 3 22.276V3a1 1 0 0 1 1-1m15 17.965V4H5v15.965l7-3.124zM12 13.5l-2.939 1.545.561-3.272-2.377-2.318 3.286-.478L12 6l1.47 2.977 3.285.478-2.377 2.318.56 3.272z"
    /></symbol
  ><symbol id="burger" viewBox="0 0 90 72"
    ><path
      d="M87 6H3a3 3 0 0 1 0-6h84a3 3 0 0 1 0 6m3 30a3 3 0 0 0-3-3H3a3 3 0 0 0 0 6h84a3 3 0 0 0 3-3m0 33a3 3 0 0 0-3-3H3a3 3 0 0 0 0 6h84a3 3 0 0 0 3-3"
    /></symbol
  ><symbol id="camera-line" viewBox="0 0 24 24"
    ><path
      d="m9.828 5-2 2H4v12h16V7h-3.828l-2-2zM9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4zm3 15a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m0-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    /></symbol
  ><symbol id="camera" viewBox="0 0 35 31.5"
    ><path
      fill="currentColor"
      d="m21.21 3.5 3.2 3.5h7.09v21h-28V7h7.087l3.2-3.5h7.42M22.75 0h-10.5l-3.2 3.5H3.5A3.51 3.51 0 0 0 0 7v21a3.51 3.51 0 0 0 3.5 3.5h28A3.51 3.51 0 0 0 35 28V7a3.51 3.51 0 0 0-3.5-3.5h-5.547ZM17.5 12.25a5.25 5.25 0 1 1-5.25 5.25 5.265 5.265 0 0 1 5.25-5.25m0-3.5a8.75 8.75 0 1 0 8.75 8.75 8.753 8.753 0 0 0-8.75-8.75"
    /></symbol
  ><symbol id="cc-license-0" viewBox="0 0 48 48"
    ><g transform="translate(-5.5 3.5)"
      ><circle
        cx="20.836"
        cy="20.836"
        r="20.836"
        fill="#fff"
        transform="translate(8.949 -.335)"
      /><path
        d="M29.456-3.5A23.42 23.42 0 0 1 46.6 3.529a23.1 23.1 0 0 1 5.143 7.736A24.4 24.4 0 0 1 53.5 20.5a24.5 24.5 0 0 1-1.736 9.235 22 22 0 0 1-5.121 7.607 24.7 24.7 0 0 1-7.972 5.315 23.9 23.9 0 0 1-9.213 1.843 23.3 23.3 0 0 1-9.107-1.822 24.1 24.1 0 0 1-7.8-5.27A23.9 23.9 0 0 1 7.3 29.629a23.97 23.97 0 0 1 .021-18.279 24.1 24.1 0 0 1 5.293-7.865A22.69 22.69 0 0 1 29.456-3.5m.087 4.329A18.6 18.6 0 0 0 15.7 6.572a20.6 20.6 0 0 0-4.35 6.45 19.03 19.03 0 0 0 0 14.914 19.9 19.9 0 0 0 4.35 6.387 19.8 19.8 0 0 0 6.386 4.286 19.48 19.48 0 0 0 14.937-.021 20.7 20.7 0 0 0 6.535-4.328 18.44 18.44 0 0 0 5.613-13.76 19.7 19.7 0 0 0-1.457-7.543 19.2 19.2 0 0 0-4.241-6.344A19 19 0 0 0 29.543.829m-.3 15.686-3.215 1.672a3.3 3.3 0 0 0-1.264-1.5 2.85 2.85 0 0 0-1.394-.428q-3.213 0-3.215 4.243a5.27 5.27 0 0 0 .814 3.085 2.75 2.75 0 0 0 2.4 1.158 3.01 3.01 0 0 0 2.958-2.057l2.957 1.5a7.07 7.07 0 0 1-6.3 3.772 7 7 0 0 1-5.184-1.973 7.41 7.41 0 0 1-1.973-5.487 7.4 7.4 0 0 1 1.993-5.44 6.79 6.79 0 0 1 5.036-2.015 6.73 6.73 0 0 1 6.386 3.471Zm13.843 0-3.172 1.672a3.3 3.3 0 0 0-1.265-1.5 2.9 2.9 0 0 0-1.436-.428Q34 16.259 34 20.5a5.27 5.27 0 0 0 .815 3.085 2.75 2.75 0 0 0 2.4 1.158 3 3 0 0 0 2.956-2.057l3 1.5a7.37 7.37 0 0 1-2.656 2.765 6.9 6.9 0 0 1-3.643 1.007 6.99 6.99 0 0 1-5.206-1.972 7.45 7.45 0 0 1-1.953-5.486 7.4 7.4 0 0 1 1.994-5.443 6.79 6.79 0 0 1 5.035-2.015q4.458.001 6.343 3.474Z"
      /></g
    ></symbol
  ><symbol id="cc-license-by" viewBox="0 0 48 48"
    ><g transform="translate(-5.5 3.5)"
      ><circle
        cx="20.276"
        cy="20.276"
        r="20.276"
        fill="#fff"
        transform="translate(9.361 .53)"
      /><path
        d="M29.457-3.5a23.19 23.19 0 0 1 17.057 6.943A23.21 23.21 0 0 1 53.5 20.5a22.62 22.62 0 0 1-6.859 16.842A23.7 23.7 0 0 1 29.457 44.5a23.23 23.23 0 0 1-16.885-7.073A23.1 23.1 0 0 1 5.5 20.5a23.53 23.53 0 0 1 7.072-17.057A22.98 22.98 0 0 1 29.457-3.5m.086 4.329A18.69 18.69 0 0 0 15.7 6.572 19.31 19.31 0 0 0 9.828 20.5a18.86 18.86 0 0 0 5.827 13.8 18.96 18.96 0 0 0 13.886 5.828 19.26 19.26 0 0 0 13.972-5.871A18.28 18.28 0 0 0 49.17 20.5a18.97 18.97 0 0 0-5.742-13.929A18.92 18.92 0 0 0 29.543.829m6.429 13.714v9.814H33.23v11.656h-7.458V24.357H23.03v-9.814A1.535 1.535 0 0 1 24.572 13h9.858a1.5 1.5 0 0 1 1.071.45 1.46 1.46 0 0 1 .471 1.093m-9.816-6.171q0-3.384 3.344-3.385t3.343 3.385q0 3.342-3.343 3.343t-3.344-3.343"
      /></g
    ></symbol
  ><symbol id="cc-license-nc" viewBox="0 0 48 48"
    ><g transform="translate(-5.5 3.5)"
      ><circle
        cx="21.471"
        cy="21.471"
        r="21.471"
        fill="#fff"
        transform="translate(7.999 -.735)"
      /><path
        d="M29.457-3.5a23.2 23.2 0 0 1 17.057 6.942A23.12 23.12 0 0 1 53.5 20.5a22.62 22.62 0 0 1-6.859 16.843A23.7 23.7 0 0 1 29.457 44.5a23.07 23.07 0 0 1-16.885-7.114A23.05 23.05 0 0 1 5.5 20.5a23.53 23.53 0 0 1 7.072-17.057A22.98 22.98 0 0 1 29.457-3.5M10.9 14.029A18.9 18.9 0 0 0 9.828 20.5a18.86 18.86 0 0 0 5.828 13.8 19.12 19.12 0 0 0 13.885 5.786 19.08 19.08 0 0 0 13.972-5.872 17.6 17.6 0 0 0 3.3-4.2l-9.043-4.028a6.2 6.2 0 0 1-2.293 3.707 7.9 7.9 0 0 1-4.308 1.65v3.686h-2.785v-3.687a11.12 11.12 0 0 1-7.286-2.87l3.3-3.343a7.67 7.67 0 0 0 5.357 2.185 3.88 3.88 0 0 0 2.123-.557 2.01 2.01 0 0 0 .879-1.843 1.84 1.84 0 0 0-.644-1.457L29.8 22.47l-2.828-1.286-3.815-1.672ZM29.543.786A18.62 18.62 0 0 0 15.7 6.571a23 23 0 0 0-2.657 3.215l9.172 4.114a5.62 5.62 0 0 1 2.272-3.021 7.6 7.6 0 0 1 3.9-1.264V5.928h2.786v3.687a10.6 10.6 0 0 1 6 2.228l-3.129 3.214a7.1 7.1 0 0 0-4.115-1.414 4.5 4.5 0 0 0-1.992.428 1.5 1.5 0 0 0-.879 1.457 1.03 1.03 0 0 0 .214.6l3.042 1.372 2.1.943 3.858 1.714 12.3 5.485a22 22 0 0 0 .6-5.143 18.8 18.8 0 0 0-5.742-13.93A18.76 18.76 0 0 0 29.543.786"
      /></g
    ></symbol
  ><symbol id="cc-license-sa" viewBox="0 0 48 48"
    ><g transform="translate(-5.5 3.5)"
      ><circle
        cx="21.105"
        cy="21.105"
        r="21.105"
        fill="#fff"
        transform="translate(7.839 -.474)"
      /><path
        d="M29.457-3.5a23.2 23.2 0 0 1 17.057 6.986A23.07 23.07 0 0 1 53.5 20.5a22.85 22.85 0 0 1-6.859 16.885A23.7 23.7 0 0 1 29.457 44.5a23.23 23.23 0 0 1-16.885-7.072A23.1 23.1 0 0 1 5.5 20.5a23.48 23.48 0 0 1 7.072-17.013A23 23 0 0 1 29.457-3.5m.086 4.329A18.62 18.62 0 0 0 15.7 6.615 19.17 19.17 0 0 0 9.828 20.5a18.77 18.77 0 0 0 5.827 13.8 18.96 18.96 0 0 0 13.886 5.828 19.27 19.27 0 0 0 13.972-5.871A18.37 18.37 0 0 0 49.17 20.5a18.74 18.74 0 0 0-5.742-13.885A18.75 18.75 0 0 0 29.543.829M18.828 17.114a10.7 10.7 0 0 1 3.556-6.836 10.47 10.47 0 0 1 6.986-2.421 11.62 11.62 0 0 1 9 3.642 13.28 13.28 0 0 1 3.343 9.343 12.84 12.84 0 0 1-3.47 9.192 11.84 11.84 0 0 1-9 3.665 10.68 10.68 0 0 1-7.028-2.443 10.38 10.38 0 0 1-3.557-6.943H24.7q.214 4.372 5.272 4.372a4.76 4.76 0 0 0 4.071-2.185 9.9 9.9 0 0 0 1.544-5.828 10 10 0 0 0-1.414-5.807 4.69 4.69 0 0 0-4.073-1.994q-4.8 0-5.4 4.242h1.757L21.7 21.87l-4.757-4.757Z"
      /></g
    ></symbol
  ><symbol id="chat-voice-line" viewBox="0 0 24 24"
    ><path
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10H2l2.929-2.929A9.97 9.97 0 0 1 2 12m4.828 8H12a8 8 0 1 0-8-8c0 2.152.851 4.165 2.343 5.657l1.414 1.414zM11 6h2v12h-2zM7 9h2v6H7zm8 0h2v6h-2z"
    /></symbol
  ><symbol id="checkbox" viewBox="0 0 20 20"
    ><path fill="none" d="M0 0h20v20H0z" /><path
      fill="currentColor"
      d="M15.44 3H4.56A1.56 1.56 0 0 0 3 4.56v10.88A1.56 1.56 0 0 0 4.56 17h10.88A1.56 1.56 0 0 0 17 15.44V4.56A1.56 1.56 0 0 0 15.44 3m0 12.44H4.56V4.56h10.88zm-.78-7.77-1.1-1.1-5.12 5.12-2.01-2-1.1 1.1 3.11 3.1z"
    /></symbol
  ><symbol id="checkmark-small" viewBox="0 0 17.748 14.41"
    ><path
      fill="currentColor"
      d="M5.64 11.369 1.433 6.888 0 8.403l5.64 6.007L17.748 1.515 16.326 0Z"
    /></symbol
  ><symbol id="checkmark" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0Z" /><path
      fill="currentColor"
      d="m10 15.17 9.2-9.2 1.4 1.42L10 18l-6.36-6.36 1.41-1.42Z"
    /></symbol
  ><symbol id="clipboard-copy" viewBox="0 0 20 20"
    ><path fill="none" d="M0 0h20v20H0z" /><path
      d="M14.471 2H7.588a1.57 1.57 0 0 0-1.529 1.6v9.6a1.57 1.57 0 0 0 1.529 1.6h6.882A1.57 1.57 0 0 0 16 13.2V3.6A1.57 1.57 0 0 0 14.471 2m0 11.2H7.588V3.6h6.882ZM3 12.4v-1.6h1.529v1.6ZM3 8h1.529v1.6H3Zm5.353 8.4h1.529V18H8.353ZM3 15.2v-1.6h1.529v1.6ZM4.529 18A1.57 1.57 0 0 1 3 16.4h1.529Zm2.676 0H5.676v-1.6h1.53Zm3.824 0v-1.6h1.529a1.57 1.57 0 0 1-1.529 1.6m-6.5-12.8v1.6H3a1.57 1.57 0 0 1 1.529-1.6"
    /></symbol
  ><symbol id="close-circle-line" viewBox="0 0 24 24"
    ><path
      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-9.414 2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415z"
    /></symbol
  ><symbol id="close-line" viewBox="0 0 24 24"
    ><path
      d="m12 10.587 4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.415 1.414-4.95-4.95-4.949 4.95-1.414-1.415 4.95-4.95-4.95-4.95L7.05 5.638z"
    /></symbol
  ><symbol id="close" viewBox="0 0 12.728 12.728"
    ><g fill="currentColor"
      ><path d="m12.021 0 .707.708-12.02 12.02L0 12.021z" /><path
        d="m.707 0 12.021 12.021-.707.707L.001.708z"
      /></g
    ></symbol
  ><symbol id="compass" viewBox="0 0 26.662 26.662"
    ><path
      fill="currentColor"
      d="M13.331 26.662a13.331 13.331 0 1 1 13.331-13.331 13.33 13.33 0 0 1-13.331 13.331m0-2.666A10.665 10.665 0 1 0 2.666 13.331 10.665 10.665 0 0 0 13.331 24ZM18 8.665l-2.666 6.665L8.665 18l2.666-6.665Z"
    /></symbol
  ><symbol id="copy-black" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0Z" /><path
      d="M16 1H4a2.006 2.006 0 0 0-2 2v14h2V3h12Zm3 4H8a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h11a2.006 2.006 0 0 0 2-2V7a2.006 2.006 0 0 0-2-2m0 16H8V7h11Z"
    /></symbol
  ><symbol id="copy" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0Z" /><path
      fill="#FFF"
      d="M16 1H4a2.006 2.006 0 0 0-2 2v14h2V3h12Zm3 4H8a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h11a2.006 2.006 0 0 0 2-2V7a2.006 2.006 0 0 0-2-2m0 16H8V7h11Z"
    /></symbol
  ><symbol id="custom-freitext-ai" viewBox="0 0 24 24"
    ><g clip-path="url(#a)"
      ><path
        fill="#000"
        d="M14 2v2H5v16h14v-9h2v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-1 15H8v-2h5zm3-4H8v-2h8zm3.53-11.68a.507.507 0 0 1 .94 0l.254.61a4.37 4.37 0 0 0 2.25 2.327l.718.32a.53.53 0 0 1 0 .962l-.76.338a4.36 4.36 0 0 0-2.218 2.25l-.247.566a.506.506 0 0 1-.934 0l-.246-.565a4.36 4.36 0 0 0-2.22-2.251l-.76-.338a.53.53 0 0 1 0-.963l.718-.32a4.37 4.37 0 0 0 2.251-2.325zM16 9H8V7h8z"
      /></g
    ></symbol
  ><symbol id="custom-freitext" viewBox="0 0 24 24"
    ><path fill="#000" d="M8 7h8v2H8zm0 4h8v2H8zm0 4h4v2H8z" /><path
      fill="#000"
      d="m21 6.757-2 2V4H5v16h14v-2.757l2-2v5.765a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993V3a1 1 0 0 1 1-1h15.998C20.55 2 21 2.455 21 2.992zm.778 2.05 1.414 1.415L15.414 18l-1.416-.002.002-1.412z"
    /></symbol
  ><symbol id="delete-bin-6-line" viewBox="0 0 24 24"
    ><path
      d="M7 4V2h10v2h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2V4zM6 6v14h12V6zm3 3h2v8H9zm4 0h2v8h-2z"
    /></symbol
  ><symbol id="download" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0Z" /><path
      d="M3 19h18v2H3Zm10-5.828L19.071 7.1l1.414 1.414L12 17 3.515 8.515 4.929 7.1 11 13.17V2h2Z"
    /></symbol
  ><symbol id="draggable" viewBox="0 0 24 24"
    ><path
      d="M8.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    /></symbol
  ><symbol id="duplicate" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      fill-rule="nonzero"
      d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
    /></symbol
  ><symbol id="edit" viewBox="0 0 23.961 23.961"
    ><path
      fill="currentColor"
      d="m16.971 8.871-1.886-1.88L2.667 19.409v1.885h1.885zm1.885-1.885 1.885-1.885-1.885-1.881-1.885 1.885Zm-13.2 16.975H0v-5.657L17.913.391a1.333 1.333 0 0 1 1.885 0l3.772 3.772a1.333 1.333 0 0 1 0 1.885L5.657 23.961Z"
    /></symbol
  ><symbol id="email" viewBox="0 0 20 16"
    ><path
      fill="currentColor"
      d="M20 2a2.006 2.006 0 0 0-2-2H2a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h16a2.006 2.006 0 0 0 2-2Zm-2 0-8 5-8-5Zm0 12H2V4l8 5 8-5Z"
    /></symbol
  ><symbol id="emoji" viewBox="0 0 20 20"
    ><g fill="none" fill-rule="evenodd"
      ><path d="M0 0h20v20H0z" /><path
        fill="currentColor"
        fill-rule="nonzero"
        d="M10 18.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 0 1 0 16.666m0-1.666a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334m-3.333-5.834h6.666a3.333 3.333 0 0 1-6.666 0m0-1.666a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m6.666 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
      /></g
    ></symbol
  ><symbol id="emotion" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-4-7h8a4 4 0 0 1-8 0m0-2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
    /></symbol
  ><symbol id="error" viewBox="0 0 12.728 12.728"
    ><g fill="currentColor"
      ><path d="m12.021 0 .707.708-12.02 12.02L0 12.021z" /><path
        d="m.707 0 12.021 12.021-.707.707L.001.708z"
      /></g
    ></symbol
  ><symbol id="external-content" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1Zm1-2h16V7H4Zm9.452-3.513 2.535-2.534-2.537-2.54L14.865 9l3.95 3.95-3.95 3.95Zm-8.268-2.535L9.134 9l1.415 1.41-2.535 2.542 2.534 2.534L9.134 16.9Z"
    /></symbol
  ><symbol id="external-link-line" viewBox="0 0 24 24"
    ><path
      d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3z"
    /></symbol
  ><symbol id="eye" viewBox="0 0 20 20"
    ><path fill="none" d="M0 0h20v20H0z" /><path
      d="M10 5a8.14 8.14 0 0 1 7.35 4.58 8.19 8.19 0 0 1-14.7 0A8.14 8.14 0 0 1 10 5m0-1.67A9.86 9.86 0 0 0 .83 9.58a9.85 9.85 0 0 0 18.34 0A9.86 9.86 0 0 0 10 3.33m0 4.17a2.08 2.08 0 1 1-2.08 2.08A2.08 2.08 0 0 1 10 7.5m0-1.67a3.75 3.75 0 1 0 3.75 3.75A3.76 3.76 0 0 0 10 5.83"
    /></symbol
  ><symbol id="f-bold" viewBox="0 0 24 24"
    ><text
      fill="#3b4d6a"
      font-family="Roboto-Bold, Roboto"
      font-size="18"
      font-weight="700"
      transform="translate(7 19)"
    >
      <tspan x="0" y="0">F</tspan>
    </text><path fill="none" d="M0 0h24v24H0z" /></symbol
  ><symbol id="file-list-2-line" viewBox="0 0 24 24"
    ><path
      d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2V4H5v16zM8 7h8v2H8zm0 4h8v2H8zm0 4h5v2H8z"
    /></symbol
  ><symbol id="filter" viewBox="0 0 24 24"
    ><path d="M14 14v6l-4 2v-8L4 5V3h16v2zM6.404 5 12 13.394 17.596 5z" /></symbol
  ><symbol id="flag" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M12.382 3a1 1 0 0 1 .894.553L14 5h6a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-6.382a1 1 0 0 1-.894-.553L12 16H5v6H3V3zm-.618 2H5v9h8.236l1 2H19V7h-6.236z"
    /></symbol
  ><symbol id="focus-point-shadow" viewBox="0 0 27 27"
    ><g fill="currentColor" filter="url(#a)" transform="translate(1.846 1.945)"
      ><path
        d="M4 3a1 1 0 0 0-1 1v4h2V5h3V3zm16 0h-4v2h3v3h2V4a1 1 0 0 0-1-1M5 16v3h3v2H4a1 1 0 0 1-1-1v-4zm14 0v3h-3v2h4a1 1 0 0 0 1-1v-4zm-9-7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
      /></g
    ></symbol
  ><symbol id="focus-point" viewBox="0 0 20 20"
    ><path
      fill="currentColor"
      d="M3.333 2.5a.833.833 0 0 0-.833.833v3.334h1.667v-2.5h2.5V2.5zm13.334 0h-3.334v1.667h2.5v2.5H17.5V3.333a.833.833 0 0 0-.833-.833m-12.5 10.833v2.5h2.5V17.5H3.333a.833.833 0 0 1-.833-.833v-3.334zm11.666 0v2.5h-2.5V17.5h3.334c.46 0 .833-.373.833-.833v-3.334zM8.333 7.5a.833.833 0 0 0-.833.833v3.334c0 .46.373.833.833.833h3.334c.46 0 .833-.373.833-.833V8.333a.833.833 0 0 0-.833-.833z"
    /></symbol
  ><symbol id="foldable" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M4 5v14h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5h-2V5zm15.707 6.293L19 10.586l-.707.707-3 3 1.414 1.414L19 13.414l2.293 2.293 1.414-1.414zm-3 6L19 19.586l2.293-2.293 1.414 1.414-3 3-.707.707-.707-.707-3-3z"
    /></symbol
  ><symbol id="frame" viewBox="0 0 18 18"
    ><path
      fill="currentColor"
      d="M16 2v14H2V2zm0-2H2a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V2a2.006 2.006 0 0 0-2-2m-4.86 8.86-3 3.87L6 10.14 3 14h12z"
    /></symbol
  ><symbol id="grid" viewBox="0 0 24 24"
    ><g fill="none" fill-rule="evenodd"
      ><path d="M0 0h24v24H0z" /><path d="M0 0h24v24H0z" /><path
        fill="currentColor"
        fill-rule="nonzero"
        d="M3 3h8v8H3zm0 10h8v8H3zM13 3h8v8h-8zm0 10h8v8h-8zm2-8v4h4V5zm0 10v4h4v-4zM5 5v4h4V5zm0 10v4h4v-4z"
      /></g
    ></symbol
  ><symbol id="group-line" viewBox="0 0 24 24"
    ><path
      d="M2 22a8 8 0 1 1 16 0h-2a6 6 0 0 0-12 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m8.284 3.703A8 8 0 0 1 23 22h-2a6 6 0 0 0-3.537-5.473zm-.688-11.29A5.5 5.5 0 0 1 21 8.5a5.5 5.5 0 0 1-5 5.478v-2.013a3.5 3.5 0 0 0 1.041-6.609z"
    /></symbol
  ><symbol id="hFiveP" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      d="M4.795 14.738v-1.6h2.857v3.2h3.295l-.089-.041a13 13 0 0 0-.353-.151 2.44 2.44 0 0 1-.962-.655 3.2 3.2 0 0 1-.488-.694 4 4 0 0 1-.245-.632l-.006-.052 1.134-.164c.624-.09 1.154-.164 1.179-.165s.056.019.1.09a1.22 1.22 0 0 0 .87.548 1.2 1.2 0 0 0 .515-2.331 1.5 1.5 0 0 0-.632-.024 1.23 1.23 0 0 0-.743.522.4.4 0 0 1-.078.109c-.033 0-2.34-.32-2.347-.327s1-4.46 1.049-4.644l.015-.058H7.653v3.7H4.795v-3.7H2.081v8.668h2.714v-1.6Zm12.287 0v-1.6l1.085-.008a12 12 0 0 0 1.289-.038 2.82 2.82 0 0 0 1.758-.793 2.53 2.53 0 0 0 .69-1.616 4.5 4.5 0 0 0-.028-.942 2.26 2.26 0 0 0-1.893-1.983 10.2 10.2 0 0 0-2.406-.091l-1.924-.007v1.779h-3.925l-.058.244-.16.677c-.084.355-.1.431-.074.423l.216-.08a5.5 5.5 0 0 1 .849-.233 6 6 0 0 1 .946 0 3 3 0 0 1 1.409.474 3.4 3.4 0 0 1 .736.725 3.04 3.04 0 0 1 .113 3.062 4 4 0 0 1-.2.364 2.6 2.6 0 0 1-1.29 1.062 1.1 1.1 0 0 0-.357.159c-.008.012.509.018 1.606.018h1.617Zm0-4.338v-.96h.538c.858 0 1.134.054 1.361.268a.9.9 0 0 1 .295.688.78.78 0 0 1-.257.636c-.264.263-.549.327-1.447.327h-.492Z"
    /></symbol
  ><symbol id="handle" viewBox="0 0 12 20"
    ><g fill="#a5a6a7" transform="rotate(90 6 6)"
      ><circle cx="2" cy="2" r="2" /><circle cx="2" cy="2" r="2" transform="translate(8)" /><circle
        cx="2"
        cy="2"
        r="2"
        transform="translate(16)"
      /></g
    ><g fill="#a5a6a7" transform="rotate(90 2 2)"
      ><circle cx="2" cy="2" r="2" /><circle cx="2" cy="2" r="2" transform="translate(8)" /><circle
        cx="2"
        cy="2"
        r="2"
        transform="translate(16)"
      /></g
    ></symbol
  ><symbol id="heart" viewBox="0 0 24 24"
    ><g fill="none" fill-rule="evenodd"
      ><path d="M0 0h24v24H0z" /><path d="M0 0h24v24H0z" /><path
        fill="currentColor"
        fill-rule="nonzero"
        d="M20.243 4.757a6 6 0 0 1 .236 8.236l-8.48 8.492-8.478-8.492a6 6 0 0 1 8.48-8.464 6 6 0 0 1 8.242.228M5.172 6.172a4 4 0 0 0-.192 5.451L12 18.654l7.02-7.03a4 4 0 0 0-5.646-5.64l-4.202 4.203-1.415-1.414 2.825-2.827-.082-.069a4 4 0 0 0-5.328.295"
      /></g
    ></symbol
  ><symbol id="home-light" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0Z" /><path
      fill="#3b4d6a"
      d="m12 2.97 7 7.32V19h-3v-6H8v6H5v-8.7zM12 0 3 9.28V21h7v-6h4v6h7V9.28Z"
    /></symbol
  ><symbol id="home-white" viewBox="0 0 18 21"
    ><path fill="#fff" d="M9 0 0 9.28V21h7v-6h4v6h7V9.28Z" /></symbol
  ><symbol id="home" viewBox="0 0 18 21"
    ><path fill="currentColor" d="M9 0 0 9.28V21h7v-6h4v6h7V9.28Z" /></symbol
  ><symbol id="image" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0Z" /><path
      d="M19 5v14H5V5zm0-2H5a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V5a2.006 2.006 0 0 0-2-2m-4.86 8.86-3 3.87L9 13.14 6 17h12z"
    /></symbol
  ><symbol id="info" viewBox="0 0 28 28"
    ><circle cx="14" cy="14" r="14" fill="#3b4d6a" /><rect
      width="2.768"
      height="9.227"
      fill="#fff"
      rx="1"
      transform="translate(12.457 12.918)"
    /><circle
      cx="2.307"
      cy="2.307"
      r="2.307"
      fill="#fff"
      transform="translate(11.534 6.459)"
    /></symbol
  ><symbol id="infoMenu" viewBox="0 0 24.001 24"
    ><circle cx="12" cy="12" r="12" fill="#fff" /><path
      fill="currentColor"
      d="M12 24a12 12 0 1 1 8.487-3.515A11.92 11.92 0 0 1 12 24M9.361 8.74v1.18a.586.586 0 0 0 .5.62l.12.018a.4.4 0 0 1 .13.022l.105.025.064.015.6.1v6.3l-.6.1-.3.059-.12.021a.585.585 0 0 0-.5.619V19h5.5v-1.181a.585.585 0 0 0-.5-.619l-.12-.021a.5.5 0 0 1-.129-.019 1 1 0 0 0-.17-.04l-.6-.1V8.741Zm2.759-4.58a1.8 1.8 0 0 0-.62.139 1.4 1.4 0 0 0-.48.321 1.5 1.5 0 0 0-.339.5 1.7 1.7 0 0 0-.12.62 1.5 1.5 0 0 0 .12.6 1.6 1.6 0 0 0 .339.5 1.6 1.6 0 0 0 .48.342 1.67 1.67 0 0 0 1.242 0 1.5 1.5 0 0 0 .5-.342 1.6 1.6 0 0 0 .339-.5 1.5 1.5 0 0 0 .139-.6 1.7 1.7 0 0 0-.139-.62 1.4 1.4 0 0 0-.339-.5 1.5 1.5 0 0 0-.5-.321 1.8 1.8 0 0 0-.623-.138Z"
    /></symbol
  ><symbol id="information-line" viewBox="0 0 24 24"
    ><path
      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16M11 7h2v2h-2zm0 4h2v6h-2z"
    /></symbol
  ><symbol id="k-italic" viewBox="0 0 24 24"
    ><text
      fill="#3b4d6a"
      font-family="Roboto-Italic, Roboto"
      font-size="18"
      font-style="italic"
      transform="translate(6 19)"
    >
      <tspan x="0" y="0">K</tspan>
    </text><path fill="none" d="M0 0h24v24H0z" /></symbol
  ><symbol id="key" viewBox="0 0 20 20"
    ><path fill="none" d="M0 0h20v20H0z" /><path
      fill="currentColor"
      d="M18.33 15.83h-5V12.5H11.1a5.83 5.83 0 1 1 0-5H20v5h-1.67zM15 14.17h1.67v-3.34h1.66V9.17H9.95l-.2-.56a4.17 4.17 0 1 0 0 2.78l.2-.56H15zM5.83 12.5a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5m0-3.33a.83.83 0 1 0 .84.83.84.84 0 0 0-.84-.83"
    /></symbol
  ><symbol id="lamp" viewBox="0 0 21.334 27.999"
    ><path
      fill="currentColor"
      d="M7.964 21.332h1.369v-6.667H12v6.667h1.369a7.66 7.66 0 0 1 2.32-4.369c.151-.163 1.109-1.156 1.223-1.3a8 8 0 1 0-12.493 0c.115.143 1.076 1.137 1.224 1.3a7.66 7.66 0 0 1 2.321 4.371ZM8 23.999v1.333h5.333v-1.333Zm-5.661-6.667a10.667 10.667 0 1 1 16.653 0C18.165 18.364 16 19.999 16 21.999v3.333a2.667 2.667 0 0 1-2.667 2.667H8a2.667 2.667 0 0 1-2.667-2.667v-3.333c0-2-2.166-3.635-2.994-4.667"
    /></symbol
  ><symbol id="latex" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      d="m22.666 12-5.033 5.028-1.257-1.257L20.152 12l-3.771-3.771 1.252-1.257ZM3.847 12l3.771 3.771-1.257 1.257L1.333 12l5.028-5.028 1.257 1.257Zm6.186 8H8.142l5.824-16h1.892Z"
    /></symbol
  ><symbol id="leaf" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M20.998 3v2c0 9.627-5.373 14-12 14H5.241a17 17 0 0 0-.243 3h-2c0-1.363.116-2.6.346-3.732Q2.999 16.327 2.998 13c0-5.523 4.477-10 10-10 2 0 4 1 8 0m-8 2a8 8 0 0 0-8 8q0 .543.01 1.046c1.254-1.978 3.091-3.541 5.494-4.914l.992 1.736C8.64 12.5 6.746 14.354 5.774 17h3.224c6.015 0 9.871-3.973 9.997-11.612-1.372.133-2.647.048-4.22-.188-1.15-.173-1.376-.2-1.777-.2"
    /></symbol
  ><symbol id="learningapps" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      d="m7.05 14.121-2.121 2.122 2.828 2.828L19.071 7.757l-2.828-2.828-2.122 2.121 1.414 1.414-1.414 1.415-1.414-1.414-1.414 1.414 1.414 1.414-1.414 1.414-1.414-1.414-1.414 1.414 1.414 1.414-1.414 1.415Zm9.9-11.314 4.242 4.243a1 1 0 0 1 0 1.414L8.465 21.192a1 1 0 0 1-1.414 0L2.808 16.95a1 1 0 0 1 0-1.414L15.536 2.808a1 1 0 0 1 1.414 0Zm-2.829 15.557 1.414-1.414 2.242 2.242h1.414v-1.414l-2.241-2.243 1.414-1.414L21 16.757V21h-4.242ZM5.636 9.878 2.808 7.05a1 1 0 0 1 0-1.414l2.828-2.829a1 1 0 0 1 1.414 0l2.829 2.828L8.464 7.05 6.343 4.928 4.929 6.343 7.05 8.464Z"
    /></symbol
  ><symbol id="lernetz-logo-without-claim" viewBox="0 0 425.2 73.6"
    ><path
      d="M60.3 39.64v25.42h35.53a4.26 4.26 0 1 1 0 8.51H55.48a4.42 4.42 0 0 1-4.41-4.41V4.42A4.42 4.42 0 0 1 55.48 0h40.35a4.35 4.35 0 0 1 4.41 4.26 4.34 4.34 0 0 1-4.41 4.25H60.3v22.42H91a4.36 4.36 0 1 1 0 8.71Zm99.84 20.3-2.91-6.34-5.71-12.42c2.84-1.1 4.16-1.53 6.17-3A17.1 17.1 0 0 0 163 32.6a19.6 19.6 0 0 0 2.93-11.11c0-7.2-3-11.34-3-11.34a19 19 0 0 0-5.94-6.21C152.72 1 146.41.31 146.41.31A76 76 0 0 0 137 0h-20a4.42 4.42 0 0 0-4.41 4.41v64.75a4.42 4.42 0 0 0 4.41 4.41h.41a4.43 4.43 0 0 0 4.41-4.41V42.89l20.33.07v.09a5 5 0 0 0 .21.63l12.51 27.25a4.43 4.43 0 0 0 5.85 2.17l.48-.22a4.43 4.43 0 0 0 2.19-5.88ZM137 34.35h-15.21V8.52H137c2.43 0 7.84.08 10.2.66 0 0 9.3 1.46 9.16 12.31-.29 9.09-4.94 11.2-9.61 12.33a48 48 0 0 1-9.75.53M341.75 8.62v60.54a4.43 4.43 0 0 1-4.41 4.41h-.52a4.42 4.42 0 0 1-4.41-4.41V8.62h-17.48a4.36 4.36 0 0 1-4.41-4.3A4.37 4.37 0 0 1 314.93 0h44.3a4.38 4.38 0 0 1 4.41 4.31 4.37 4.37 0 0 1-4.41 4.3ZM9.23 4.42V65h31a4.31 4.31 0 1 1 0 8.61H4.41A4.43 4.43 0 0 1 0 69.16V4.42A4.43 4.43 0 0 1 4.41 0h.41a4.42 4.42 0 0 1 4.41 4.42m254.7 35.26v25.41h35.54a4.26 4.26 0 1 1 0 8.51h-40.36a4.42 4.42 0 0 1-4.41-4.41V4.46a4.42 4.42 0 0 1 4.41-4.41h40.36a4.35 4.35 0 0 1 4.41 4.25 4.35 4.35 0 0 1-4.41 4.25h-35.54V31h30.66a4.36 4.36 0 1 1 0 8.72ZM424.45 7a4 4 0 0 0 .75-2.33v-.53a4.07 4.07 0 0 0-4.06-4.06H374.3a4.06 4.06 0 0 0-4.06 4.06v.57a4.07 4.07 0 0 0 4.06 4.06h37.45L371.4 66.24l-.13.23a4 4 0 0 0-.87 2.47v.57a4.08 4.08 0 0 0 4.06 4.06H421a4.07 4.07 0 0 0 4.06-4.06v-.57a4.07 4.07 0 0 0-4.06-4.06h-37.1L424.24 7.4c.08-.11.14-.24.21-.4M216.59 37.4c3.84 4.72 15.33 18.73 15.33 18.73V4.41A4.42 4.42 0 0 1 236.35 0h.5a4.42 4.42 0 0 1 4.41 4.41v64.75a4.42 4.42 0 0 1-4.41 4.41h-.11a4.65 4.65 0 0 1-3-.83 6 6 0 0 1-1-1c-5.55-6.73-21.19-25.88-23.39-28.55-.22-.31.12-.62.12-.62l6.44-5.28a.49.49 0 0 1 .66.08M203.6 36l-15.38-18.56v51.72a4.43 4.43 0 0 1-4.41 4.41h-.5a4.43 4.43 0 0 1-4.41-4.42V4.41A4.42 4.42 0 0 1 183.29 0h.11a4.6 4.6 0 0 1 2.95.83 6.2 6.2 0 0 1 1 1c5.59 6.78 21.34 26 23.35 28.41a.42.42 0 0 1 0 .62s-4.58 3.76-6.5 5.31a.43.43 0 0 1-.62-.08"
      class="cls-1"
    /></symbol
  ><symbol id="letterT" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      fill="currentColor"
      d="M10.5 19.996v-13H4v-3h16v3h-6.5v13Z"
    /></symbol
  ><symbol id="lightbulb" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M9.973 18H11v-5h2v5h1.027c.132-1.202.745-2.193 1.74-3.277.113-.122.832-.867.917-.973a6 6 0 1 0-9.37-.002c.086.107.807.853.918.974.996 1.084 1.609 2.076 1.741 3.278M10 20v1h4v-1zm-4.246-5a8 8 0 1 1 12.49.002C17.624 15.774 16 17 16 18.5V21a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2.5C8 17 6.375 15.774 5.754 15"
    /></symbol
  ><symbol id="link" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0Z" /><path
      d="m17.657 14.828-1.414-1.414L17.657 12A4 4 0 0 0 12 6.343l-1.414 1.414-1.414-1.414 1.414-1.414a6 6 0 1 1 8.485 8.485zm-2.829 2.829-1.414 1.414a6 6 0 1 1-8.485-8.485l1.414-1.414 1.414 1.414L6.343 12A4 4 0 0 0 12 17.657l1.414-1.414Zm0-9.9 1.415 1.415-7.071 7.07-1.415-1.414z"
    /></symbol
  ><symbol id="list-image" viewBox="0 0 24 24"
    ><g fill="none" fill-rule="evenodd"
      ><path d="M0 0h24v24H0z" /><path
        fill="currentColor"
        fill-rule="nonzero"
        d="M21 3v8H3V3zm-2 2H5v4h14zM21 13v8H3v-8zm-2 2H5v4h14z"
      /></g
    ></symbol
  ><symbol id="list-ordered" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0Z" /><path
      fill="#3b4d6a"
      d="M7 5h14v2H7zM7 17h14v2H7zM7 11h14v2H7zM4.3 8h-.8V5l-.9.2v-.6L4.2 4h.1ZM5 14H2.3v-.5l1.3-1.4c.2-.2.3-.4.4-.5a.6.6 0 0 0 .1-.4c0-.2 0-.3-.1-.4a.5.5 0 0 0-.8 0c-.2.1-.2.3-.2.5h-.8a1.9 1.9 0 0 1 .2-.7 1.2 1.2 0 0 1 .5-.5 1.5 1.5 0 0 1 .7-.1 1.7 1.7 0 0 1 1 .3 1.14 1.14 0 0 1 .3.8 1.4 1.4 0 0 1-.2.6c-.1.2-.3.4-.5.7l-.9 1H5ZM3.1 17.6h.4a.52.52 0 0 0 .4-.2c.1-.1.1-.2.1-.4s0-.3-.1-.4-.2-.1-.4-.1-.3 0-.4.1-.2.2-.2.3h-.6a1.4 1.4 0 0 1 .2-.6 1 1 0 0 1 .5-.4 1.5 1.5 0 0 1 .7-.1 1.5 1.5 0 0 1 1 .3 1.23 1.23 0 0 1 .4.8.76.76 0 0 1-.2.5c-.1.2-.3.3-.4.4a1 1 0 0 1 .5.4c-.1.2 0 .4 0 .6a1.09 1.09 0 0 1-.4.9 1.5 1.5 0 0 1-1 .3 1.7 1.7 0 0 1-1-.3.9.9 0 0 1-.4-.8H3a.76.76 0 0 0 .2.4.6.6 0 0 0 .4.1c.2 0 .3 0 .4-.1a.52.52 0 0 0 .2-.4c0-.4-.2-.6-.7-.6h-.4Z"
    /></symbol
  ><symbol id="list-unordered" viewBox="0 0 23 24"
    ><path fill="none" d="M0 0h23v24H0Z" /><path
      fill="#3b4d6a"
      d="M3.92 10.5a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3m0-6A1.46 1.46 0 0 0 2.5 6a1.46 1.46 0 0 0 1.42 1.5A1.46 1.46 0 0 0 5.34 6a1.46 1.46 0 0 0-1.42-1.5m0 12a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3M6.76 19H20v-2H6.76Zm0-6H20v-2H6.76Zm0-8v2H20V5Z"
    /></symbol
  ><symbol id="list" viewBox="0 0 30 23"
    ><g fill="currentColor" transform="translate(-662 -2651)"
      ><path d="M671 2670h21v3h-21zM671 2661h21v3h-21zM671 2652h21v3h-21z" /><circle
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="translate(662 2651)"
      /><circle cx="2.5" cy="2.5" r="2.5" transform="translate(662 2660)" /><circle
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="translate(662 2669)"
      /></g
    ></symbol
  ><symbol id="loader-4-line" viewBox="0 0 24 24"
    ><path d="M18.364 5.636 16.95 7.05A7 7 0 1 0 19 12h2a9 9 0 1 1-2.636-6.364" /></symbol
  ><symbol id="location" viewBox="0 0 14 20"
    ><path
      fill="currentColor"
      d="M7 0a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7M2 7a5 5 0 0 1 10 0c0 2.88-2.88 7.19-5 9.88C4.92 14.21 2 9.85 2 7"
    /><circle
      cx="2.5"
      cy="2.5"
      r="2.5"
      fill="currentColor"
      transform="translate(4.5 4.5)"
    /></symbol
  ><symbol id="logo-plain" viewBox="0 0 78 28"
    ><text
      fill="#242727"
      font-family="Helvetica-Bold, Helvetica"
      font-size="28"
      font-weight="700"
      transform="translate(0 22)"><tspan x="0" y="0">zeb.is</tspan></text
    ></symbol
  ><symbol id="logo-zebis-digital" viewBox="0 0 148 34"
    ><text
      fill="#242727"
      font-family="Aleo-Bold, Aleo"
      font-size="28"
      font-weight="700"
      transform="translate(0 28)"
    >
      <tspan x="0" y="0">zebis</tspan>
    </text><text
      fill="#242727"
      font-family="Aleo-Light, Aleo"
      font-size="28"
      font-weight="300"
      transform="translate(63 28)"
    >
      <tspan x="0" y="0">.digital</tspan>
    </text></symbol
  ><symbol id="logo" viewBox="0 0 204.52 28"
    ><g id="Gruppe_21"
      ><g id="Gruppe_19"
        ><g id="zebis_OER" class="cls-1"
          ><g class="cls-1"
            ><path
              d="M12 23H.5v-1.46A1.6 1.6 0 0 1 .62 21a1.8 1.8 0 0 1 .38-.63l6.84-9.07H3.33c-.07.74-.13 1.21-.17 1.4a.62.62 0 0 1-.64.53H.9V8.64h10.89v1.42a2.1 2.1 0 0 1-.11.7 5 5 0 0 1-.34.59l-6.8 9h5l.17-1.51a.61.61 0 0 1 .64-.53H12zM22.4 8.83a5.4 5.4 0 0 1 2 1.29 5.8 5.8 0 0 1 1.29 2 7.9 7.9 0 0 1 .47 2.75 5 5 0 0 1-.05.67A1.5 1.5 0 0 1 26 16a.46.46 0 0 1-.26.23 1.1 1.1 0 0 1-.39.05h-8.91a5 5 0 0 0 1.2 3.25 3.72 3.72 0 0 0 2.74 1 4.4 4.4 0 0 0 1.43-.2 5.7 5.7 0 0 0 1.07-.45l.4-.21a3 3 0 0 0 .41-.21 1.16 1.16 0 0 1 .64-.19.8.8 0 0 1 .39.08.6.6 0 0 1 .26.22l1 1.26A6.6 6.6 0 0 1 24.7 22a7.3 7.3 0 0 1-1.49.73 10 10 0 0 1-1.59.36 9.4 9.4 0 0 1-1.57.12 7.6 7.6 0 0 1-2.77-.48A6.4 6.4 0 0 1 15 21.24a6.9 6.9 0 0 1-1.52-2.41A9.5 9.5 0 0 1 13 15.5a8.1 8.1 0 0 1 .48-2.75 6.6 6.6 0 0 1 1.37-2.27A6.4 6.4 0 0 1 17 9a7.3 7.3 0 0 1 2.91-.56 7.1 7.1 0 0 1 2.49.39m-4.79 2.91a4.3 4.3 0 0 0-1.09 2.41H23a4.6 4.6 0 0 0-.2-1.26 3.3 3.3 0 0 0-.56-1 2.34 2.34 0 0 0-1-.7 3.3 3.3 0 0 0-1.24-.31 3.2 3.2 0 0 0-2.39.86m24.78 3.95a10.3 10.3 0 0 1-.45 3 6.7 6.7 0 0 1-1.23 2.38 5.75 5.75 0 0 1-2 1.57 5.6 5.6 0 0 1-2.55.56 36 36 0 0 1-7-.79V5l-.87-.14-.29-.09h-.39a.83.83 0 0 1-.7-.87V2.2h5.68v8.2a6.5 6.5 0 0 1 1.93-1.46 5.64 5.64 0 0 1 2.52-.53 4.66 4.66 0 0 1 3.84 1.88A6.7 6.7 0 0 1 42 12.58a11.6 11.6 0 0 1 .39 3.11m-3.58 0a9.4 9.4 0 0 0-.2-2.13 4.3 4.3 0 0 0-.61-1.42 2.2 2.2 0 0 0-.92-.79 2.8 2.8 0 0 0-1.2-.25 3.45 3.45 0 0 0-1.85.45 5.2 5.2 0 0 0-1.43 1.29v7.47a15.3 15.3 0 0 0 2.8.25 3.2 3.2 0 0 0 1.4-.28 2.7 2.7 0 0 0 1.06-.89 4.3 4.3 0 0 0 .7-1.51 8.5 8.5 0 0 0 .25-2.19M51 21.35V23h-7.7v-1.65a.81.81 0 0 1 .7-.87h.16l.42-.08.84-.14v-8.85l-.84-.14-.23-.06H44a.83.83 0 0 1-.7-.87v-1.7h5.57v11.59l.84.14.24.05a.6.6 0 0 0 .18 0h.17a.82.82 0 0 1 .7.93M49.22 5.28a2.3 2.3 0 0 1-.47.7 2.1 2.1 0 0 1-.7.47 2.3 2.3 0 0 1-1.74 0 2.1 2.1 0 0 1-.67-.45 2.4 2.4 0 0 1-.48-.7 2.2 2.2 0 0 1-.16-.86 2.4 2.4 0 0 1 .16-.87 2.2 2.2 0 0 1 .48-.7 1.8 1.8 0 0 1 .67-.45 2 2 0 0 1 1.74 0 2.07 2.07 0 0 1 1.17 1.15 2.3 2.3 0 0 1 .2.87 2.1 2.1 0 0 1-.2.84m13.16 13.16a4.9 4.9 0 0 1-.38 1.93 4.43 4.43 0 0 1-2.88 2.49 7.4 7.4 0 0 1-2.47.36 13.5 13.5 0 0 1-2.48-.22 12 12 0 0 1-2.09-.56v-4.06h1.62a.63.63 0 0 1 .65.53c0 .21.1.76.19 1.65a8.5 8.5 0 0 0 2.27.23 4 4 0 0 0 1.07-.14 2.1 2.1 0 0 0 .72-.39 1.2 1.2 0 0 0 .42-.54 1.8 1.8 0 0 0 .12-.67 1.16 1.16 0 0 0-.29-.81 2.6 2.6 0 0 0-.81-.56 6.5 6.5 0 0 0-1.12-.42l-1.31-.42a11 11 0 0 1-1.29-.53 4.3 4.3 0 0 1-1.15-.76 3 3 0 0 1-.78-1.12 3.9 3.9 0 0 1-.31-1.62 4.1 4.1 0 0 1 .34-1.68 3.8 3.8 0 0 1 1-1.4 4.9 4.9 0 0 1 1.71-1 7.1 7.1 0 0 1 2.32-.37 9.6 9.6 0 0 1 1.88.16 24 24 0 0 1 2.32.6v4.06h-1.6a.62.62 0 0 1-.64-.53 13 13 0 0 1-.2-1.57 6 6 0 0 0-1.68-.2 2.73 2.73 0 0 0-1.6.42 1.34 1.34 0 0 0-.59 1.15 1.2 1.2 0 0 0 .31.78 2.7 2.7 0 0 0 .79.54 8 8 0 0 0 1.12.44c.15 0 .58.17 1.28.4a11 11 0 0 1 1.32.53 4 4 0 0 1 1.12.73 2.9 2.9 0 0 1 .79 1 3.6 3.6 0 0 1 .31 1.57m26.45-.23a9.34 9.34 0 0 1-3.64 3.68 11.32 11.32 0 0 1-10.61 0 9.43 9.43 0 0 1-3.66-3.67 10.9 10.9 0 0 1-1.31-5.38 10.9 10.9 0 0 1 1.31-5.37 9.33 9.33 0 0 1 3.66-3.66 10.8 10.8 0 0 1 5.3-1.3 10.5 10.5 0 0 1 5.34 1.35 9.3 9.3 0 0 1 3.62 3.69 10.8 10.8 0 0 1 1.29 5.29 10.84 10.84 0 0 1-1.3 5.37M84.6 7.7a5.86 5.86 0 0 0-4.72-1.95 5.93 5.93 0 0 0-4.77 2 7.7 7.7 0 0 0-1.67 5.15 7.7 7.7 0 0 0 1.68 5.2 5.94 5.94 0 0 0 4.76 1.9 5.82 5.82 0 0 0 4.73-2 7.7 7.7 0 0 0 1.66-5.18A7.68 7.68 0 0 0 84.6 7.7m21.4.38h-1.63a.62.62 0 0 1-.64-.54c-.1-.72-.16-1.32-.2-1.79H97v5.6h6.86v2.91H97V20h6.52c0-.47.1-1.07.2-1.8a.62.62 0 0 1 .64-.53H106V23H91.11v-1.65a.81.81 0 0 1 .7-.87h.35l.24-.05.84-.14V5.53l-.84-.14-.24-.06L92 5.3h-.17a.82.82 0 0 1-.7-.87V2.76H106zm19.3 13.27V23h-3.78a1.53 1.53 0 0 1-.84-.2 1.9 1.9 0 0 1-.56-.56l-4.26-6.49a1.5 1.5 0 0 0-.53-.51 1.8 1.8 0 0 0-.84-.16h-1.43v5.15l.84.14.24.05h.35a.81.81 0 0 1 .7.87V23h-8v-1.65a.82.82 0 0 1 .7-.87h.17l.42-.08.84-.14V5.53l-.84-.14-.24-.06a.6.6 0 0 0-.18 0h-.17a.83.83 0 0 1-.7-.87v-1.7h8.09a13.2 13.2 0 0 1 3.56.42 7.1 7.1 0 0 1 2.41 1.2 4.7 4.7 0 0 1 1.4 1.85 6 6 0 0 1 .45 2.35 6.6 6.6 0 0 1-.31 1.93 5.7 5.7 0 0 1-.87 1.65 5.2 5.2 0 0 1-1.4 1.29 8 8 0 0 1-1.9.9 3.8 3.8 0 0 1 1.23 1.17l3.15 4.71.87.14.26.05h.44a.82.82 0 0 1 .73.93m-6.92-10a3.2 3.2 0 0 0 .76-1.12 3.8 3.8 0 0 0 .25-1.4 2.93 2.93 0 0 0-1-2.38 4.85 4.85 0 0 0-3.11-.81h-2.21v6.72h2.16a6.4 6.4 0 0 0 1.85-.28 3.5 3.5 0 0 0 1.3-.7z"
              class="cls-2"
            /></g
          ></g
        ></g
      ><g id="Gruppe_20"
        ><g id="Editor" class="cls-1"
          ><g class="cls-1"
            ><path
              d="M142.17 7.26h-.7c-.36 0-.55-.22-.59-.67l-.11-2.24h-9.05v8h7.9v1.15h-7.9v8.3h9.05l.11-2.22c0-.46.23-.7.59-.7h.7V23h-14.23v-.56c0-.32.18-.48.54-.5l1.82-.06V4.27l-1.82-.06c-.38 0-.56-.2-.56-.5v-.53h14.25zM155.92 23a.35.35 0 0 1-.4-.36l-.14-2.22a6 6 0 0 1-4.95 2.75 4.66 4.66 0 0 1-4.1-1.89 8.9 8.9 0 0 1-1.33-5.22 9.15 9.15 0 0 1 .71-3.7 5.9 5.9 0 0 1 2.09-2.59 5.6 5.6 0 0 1 3.27-.94 5 5 0 0 1 4.26 2.05V3.74l-1.46-.06c-.37 0-.56-.21-.56-.5v-.56h3.33v19.29h1.35c.35 0 .53.18.53.5V23zm-4.6-13.13a4.28 4.28 0 0 0-3.71 1.72 7.46 7.46 0 0 0-1.24 4.47q0 6 4.45 6a5.51 5.51 0 0 0 4.51-2.71v-7.3a4.58 4.58 0 0 0-4.01-2.18m15.07 12.57V23H161v-.56c0-.3.19-.47.56-.5l1.46-.06v-11.7l-1.46-.06c-.37 0-.56-.2-.56-.5v-.56h3.36v12.82l1.46.06c.38.06.57.2.57.5m-3.57-17.3a1.24 1.24 0 0 1-.35-.9 1.12 1.12 0 0 1 .35-.85 1.15 1.15 0 0 1 .88-.39 1.12 1.12 0 0 1 .85.35 1.12 1.12 0 0 1 .35.85 1.24 1.24 0 0 1-.35.9 1.13 1.13 0 0 1-.85.36 1.16 1.16 0 0 1-.88-.32m8.27 17.26a3.4 3.4 0 0 1-.75-2.37v-9.52h-2a.46.46 0 0 1-.27-.08.34.34 0 0 1-.1-.25v-.51l2.38-.17.34-5a.32.32 0 0 1 .1-.22.29.29 0 0 1 .24-.12h.64V9.5h4.4v1h-4.4V20a2.3 2.3 0 0 0 .52 1.61 1.79 1.79 0 0 0 1.41.57 3.37 3.37 0 0 0 1.91-.78.6.6 0 0 1 .25-.09.37.37 0 0 1 .31.17l.3.51a3.65 3.65 0 0 1-1.38.93 4.3 4.3 0 0 1-1.67.35 2.9 2.9 0 0 1-2.23-.87m18.45-11.59a7.76 7.76 0 0 1 1.68 5.19 7.68 7.68 0 0 1-1.68 5.21 6.6 6.6 0 0 1-9.35 0 7.68 7.68 0 0 1-1.68-5.21 7.72 7.72 0 0 1 1.7-5.22 5.83 5.83 0 0 1 4.69-2 5.76 5.76 0 0 1 4.64 2.03m-.93 9.68a7.2 7.2 0 0 0 1.24-4.49 7.3 7.3 0 0 0-1.24-4.47 5 5 0 0 0-7.45 0 7.3 7.3 0 0 0-1.25 4.5 7.27 7.27 0 0 0 1.23 4.46 5.07 5.07 0 0 0 7.47 0m15.13-11.13-.25.7a.6.6 0 0 1-.24.35.43.43 0 0 1-.41.05c-.26-.1-.5-.17-.71-.23a4 4 0 0 0-3.4.9 6.7 6.7 0 0 0-1.65 2.87v7.92l1.48.06a.7.7 0 0 1 .41.14.46.46 0 0 1 .12.36V23h-5.35v-.56a.46.46 0 0 1 .13-.36.68.68 0 0 1 .41-.14l1.48-.06V10.15l-1.51-.06a.7.7 0 0 1-.41-.14.46.46 0 0 1-.12-.36v-.53h2.74c.17 0 .28 0 .33.08a.44.44 0 0 1 .12.34l.11 3c.95-2.4 2.47-3.61 4.56-3.61a4.5 4.5 0 0 1 2.16.49"
              class="cls-2"
            /></g
          ></g
        ></g
      ></g
    ></symbol
  ><symbol id="menu" viewBox="0 0 26 6"
    ><g fill="currentColor" transform="translate(835 636)"
      ><circle cx="3" cy="3" r="3" transform="translate(-835 -636)" /><circle
        cx="3"
        cy="3"
        r="3"
        transform="translate(-825 -636)"
      /><circle cx="3" cy="3" r="3" transform="translate(-815 -636)" /></g
    ></symbol
  ><symbol id="more" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><g fill="#3b4d6a" transform="translate(-1300.5 -1935)"
      ><circle cx="2" cy="2" r="2" transform="translate(1303.5 1945)" /><circle
        cx="2"
        cy="2"
        r="2"
        transform="translate(1310.5 1945)"
      /><circle cx="2" cy="2" r="2" transform="translate(1317.5 1945)" /></g
    ></symbol
  ><symbol id="paste" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      d="M7 4V2h10v2h3.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4zm0 2H5v14h14V6h-2v2H7zm2-2v2h6V4z"
    /></symbol
  ><symbol id="pause-fill" viewBox="0 0 24 24"><path d="M6 5h2v14H6zm10 0h2v14h-2z" /></symbol
  ><symbol id="pen" viewBox="0 0 20 20"
    ><path fill="none" d="M0 0h20v20H0z" /><path
      fill="currentColor"
      d="M13.18 8.35 5.14 16.4H3.6v-1.54l8.05-8.04M14.53 2a.8.8 0 0 0-.56.23L12.5 3.7l3.8 3.8 1.46-1.46a.8.8 0 0 0 0-1.13L15.1 2.23a.8.8 0 0 0-.57-.23m-2.88 2.55L2 14.2V18h3.8l9.65-9.65z"
    /></symbol
  ><symbol id="phone" viewBox="0 0 18 18"
    ><path
      fill="currentColor"
      d="M3.54 2a12.3 12.3 0 0 0 .45 2.59l-1.2 1.2A14.8 14.8 0 0 1 2.03 2zm9.86 12.02a12.8 12.8 0 0 0 2.6.45v1.49a15.4 15.4 0 0 1-3.8-.75zM4.5 0H1a1 1 0 0 0-1 1 17 17 0 0 0 17 17 1 1 0 0 0 1-1v-3.49a1 1 0 0 0-1-1 11.4 11.4 0 0 1-3.57-.57.8.8 0 0 0-.31-.05 1.02 1.02 0 0 0-.71.29l-2.2 2.2a15.15 15.15 0 0 1-6.59-6.59l2.2-2.2a1 1 0 0 0 .25-1.02A11.4 11.4 0 0 1 5.5 1a1 1 0 0 0-1-1"
    /></symbol
  ><symbol id="plane" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M14 8.947 22 14v2l-8-2.526v5.36l3 1.666V22l-4.5-1L8 22v-1.5l3-1.667v-5.36L3 16v-2l8-5.053V3.5a1.5 1.5 0 0 1 3 0z"
    /></symbol
  ><symbol id="play-fill" viewBox="0 0 24 24"
    ><path
      d="M19.376 12.416 8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832"
    /></symbol
  ><symbol id="play-large-line" viewBox="0 0 24 24"
    ><path
      d="M8 18.392V5.608L18.226 12zM6 3.804v16.392a1 1 0 0 0 1.53.848l13.113-8.196a1 1 0 0 0 0-1.696L7.53 2.956A1 1 0 0 0 6 3.804"
    /></symbol
  ><symbol id="plus-border" viewBox="0 0 20 20"
    ><path fill="none" d="M0 0h20v20H0z" /><path
      d="M15.44 3H4.56A1.55 1.55 0 0 0 3 4.56v10.88A1.55 1.55 0 0 0 4.56 17h10.88A1.56 1.56 0 0 0 17 15.44V4.56A1.56 1.56 0 0 0 15.44 3m0 12.44H4.56V4.56h10.88zM9.22 13.9h1.56v-3.11h3.1V9.22h-3.1v-3.1H9.22v3.1h-3.1v1.56h3.1z"
    /></symbol
  ><symbol id="plus" viewBox="0 0 17 17"
    ><g fill="currentColor"><path d="M7.5 0h2v17h-2z" /><path d="M0 7.5h17v2H0z" /></g></symbol
  ><symbol id="poll" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      d="M5.763 16.25H20v-12H4v13.385Zm.692 2L2 21.75V3.25a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1Zm4.545-5h2v2h-2ZM8.567 8.063A3.5 3.5 0 1 1 12 12.25h-1v-2h1a1.5 1.5 0 1 0-1.471-1.794Z"
    /></symbol
  ><symbol id="profile-line" viewBox="0 0 24 24"
    ><path
      d="M21.008 3c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3zM20 5H4v14h16zm-2 10v2H6v-2zm-6-8v6H6V7zm6 4v2h-4v-2zm-8-2H8v2h2zm8-2v2h-4V7z"
    /></symbol
  ><symbol id="published" viewBox="0 0 24 24"
    ><path
      fill="#3b4d6a"
      d="M12.001 24a12 12 0 1 1 8.486-3.515A12 12 0 0 1 12.001 24M7.182 10.8l-.966.963 4.339 4.339 7.232-7.232-.964-.963-6.269 6.266z"
    /></symbol
  ><symbol id="qr-code-line" viewBox="0 0 24 24"
    ><path
      d="M16 17v-1h-3v-3h3v2h2v2h-1v2h-2v2h-2v-3h2v-1zm5 4h-4v-2h2v-2h2zM3 3h8v8H3zm2 2v4h4V5zm8-2h8v8h-8zm2 2v4h4V5zM3 13h8v8H3zm2 2v4h4v-4zm13-2h3v2h-3zM6 6h2v2H6zm0 10h2v2H6zM16 6h2v2h-2z"
    /></symbol
  ><symbol id="question-line" viewBox="0 0 24 24"
    ><path
      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-1-5h2v2h-2zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.501 3.501 0 1 1 13 13.355"
    /></symbol
  ><symbol id="question-mark-blue" viewBox="0 0 24 26"
    ><g transform="translate(-925 -214)"
      ><rect width="24" height="24" fill="#3B4D6A" rx="12" transform="translate(925 216)" /><text
        fill="#fff"
        font-family="Roboto-Bold, Roboto"
        font-size="20"
        font-weight="700"
        transform="translate(932 235)"
      >
        <tspan x="0" y="0">?</tspan>
      </text></g
    ></symbol
  ><symbol id="question-mark" viewBox="0 0 24 26"
    ><g transform="translate(-925 -214)"
      ><rect width="24" height="24" fill="#d2d2d2" rx="12" transform="translate(925 216)" /><text
        fill="#fff"
        font-family="Roboto-Bold, Roboto"
        font-size="20"
        font-weight="700"
        transform="translate(932 235)"
      >
        <tspan x="0" y="0">?</tspan>
      </text></g
    ></symbol
  ><symbol id="rectangle-and-arrow" viewBox="0 0 20 20"
    ><path fill="none" d="M0 0h20v20H0z" /><path
      d="M15.44 15.44H4.56V4.56H10V3H4.56A1.55 1.55 0 0 0 3 4.56v10.88A1.55 1.55 0 0 0 4.56 17h10.88A1.56 1.56 0 0 0 17 15.44V10h-1.56zM11.56 3v1.56h2.79L6.7 12.2l1.1 1.1 7.65-7.65v2.8H17V3z"
    /></symbol
  ><symbol id="remove-answer" viewBox="0 0 14 14"
    ><path
      fill="currentColor"
      d="M14 1.41 12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7Z"
    /></symbol
  ><symbol id="repeat" viewBox="0 0 24 24"
    ><g fill="none"
      ><path d="M0 0h24v24H0z" /><path d="M0 0h24v24H0z" /><path d="M0 0h24v24H0z" /></g
    ><path fill="currentColor" d="M12 5V1L7 6l5 5V7a6 6 0 1 1-6 6H4a8 8 0 1 0 8-8" /></symbol
  ><symbol id="restaurant" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M21 2v20h-2v-7h-4V8a6 6 0 0 1 6-6m-2 2.53C18.17 5 17 6.17 17 8v5h2zM9 13.9V22H7v-8.1A5 5 0 0 1 3 9V3h2v7h2V3h2v7h2V3h2v6a5 5 0 0 1-4 4.9"
    /></symbol
  ><symbol id="save-3-line" viewBox="0 0 24 24"
    ><path
      d="M18 19h1V6.828L17.172 5H16v4H7V5H5v14h1v-7h12zM4 3h14l2.707 2.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4 11v5h8v-5z"
    /></symbol
  ><symbol id="save" viewBox="0 0 438.53 438.53"
    ><path
      d="M432.82 121.05c-3.8-9.13-8.37-16.37-13.7-21.7l-79.95-79.94c-5.32-5.32-12.56-9.9-21.7-13.7C308.36 1.9 299.98 0 292.37 0H27.4A26.43 26.43 0 0 0 8 8c-5.33 5.32-8 11.8-8 19.4v383.73c0 7.61 2.67 14.08 8 19.41s11.8 8 19.4 8h383.73c7.62 0 14.09-2.67 19.41-8a26.44 26.44 0 0 0 8-19.41V146.18c0-7.62-1.91-16-5.72-25.13m-250.1-75.37c0-2.48.91-4.61 2.72-6.43a8.8 8.8 0 0 1 6.42-2.7h54.82q3.705 0 6.42 2.7a8.77 8.77 0 0 1 2.71 6.43v91.36a8.8 8.8 0 0 1-2.71 6.43 8.8 8.8 0 0 1-6.42 2.7h-54.82c-2.47 0-4.62-.9-6.42-2.7a8.8 8.8 0 0 1-2.72-6.43zm146.19 356.31H109.63V292.36h219.28zm73.09 0h-36.55V283.22c0-7.62-2.67-14.09-8-19.42s-11.8-8-19.41-8H100.5a26.44 26.44 0 0 0-19.42 8c-5.33 5.33-8 11.8-8 19.42v118.77H36.55V36.54H73.1v118.77c0 7.62 2.66 14.09 7.99 19.42 5.33 5.32 11.8 7.99 19.42 7.99h164.45c7.61 0 14.1-2.67 19.41-8 5.33-5.32 8-11.8 8-19.4V36.53c2.85 0 6.56.95 11.13 2.86 4.57 1.9 7.8 3.8 9.71 5.7l80.23 80.23c1.9 1.9 3.81 5.2 5.71 9.85 1.91 4.67 2.86 8.33 2.86 11v255.81z"
    /></symbol
  ><symbol id="search" viewBox="0 0 56.966 56.966"
    ><path
      d="M55.146 51.887 41.588 37.786A22.93 22.93 0 0 0 46.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 0 0 .083-4.242M23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17"
    /></symbol
  ><symbol id="section" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      d="m15.566 4.898-6.738 6.738-.705 2.121-1.043 1.041 2.828 2.828 1.042-1.039 2.121-.707 6.737-6.737Zm6.364 3.536a1 1 0 0 1 0 1.414l-7.778 7.778-2.121.707-1.414 1.414a1 1 0 0 1-1.414 0l-4.244-4.242a1 1 0 0 1 0-1.414l1.414-1.414.707-2.121 7.779-7.779a1 1 0 0 1 1.414 0Zm-6.364-.707 1.414 1.414-4.95 4.95-1.414-1.414Zm-10.96 9.546 2.828 2.828-1.411 1.414-4.246-1.414Z"
    /></symbol
  ><symbol id="selfassessment" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      d="M13.257 14.381v2.089a6 6 0 0 0-8 5.659h-2a8.007 8.007 0 0 1 10-7.748m-2-1.252a6 6 0 1 1 6-6 6 6 0 0 1-6 6m0-2a4 4 0 1 0-4-4 4 4 0 0 0 4 4m5.793 8.914 3.535-3.535 1.414 1.414-4.95 4.95-3.536-3.535 1.414-1.414Z"
    /></symbol
  ><symbol id="send-plane-2-fill" viewBox="0 0 24 24"
    ><path
      d="M3 13h6v-2H3V1.846a.5.5 0 0 1 .741-.439l18.462 10.155a.5.5 0 0 1 0 .876L3.741 22.592A.5.5 0 0 1 3 22.154z"
    /></symbol
  ><symbol id="share-forward-line" viewBox="0 0 24 24"
    ><path
      d="M13 14h-2a9 9 0 0 0-7.968 4.81A10 10 0 0 1 3 18C3 12.477 7.477 8 13 8V2.5L23.5 11 13 19.5zm-2-2h4v3.308L20.321 11 15 6.692V10h-2a7.98 7.98 0 0 0-6.057 2.774A11 11 0 0 1 11 12"
    /></symbol
  ><symbol id="single-multiplechoice" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      fill="currentColor"
      d="M9 15.504a6.45 6.45 0 0 1 .5-2.5H3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v6.5a6.5 6.5 0 1 1-4 6m2 0a4.5 4.5 0 1 0 4.5-4.5 4.505 4.505 0 0 0-4.5 4.5m-7.657-8 3.243 3.239 5.072-5.071-1.414-1.413-3.658 3.656-1.828-1.828Zm9.657 8a2.5 2.5 0 1 1 2.5 2.5 2.5 2.5 0 0 1-2.5-2.5"
    /></symbol
  ><symbol id="slate-editor-Add" viewBox="0 0 24 24"
    ><path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" /></symbol
  ><symbol id="slate-editor-ArrowBelow" viewBox="0 0 24 24"
    ><g fill="none" fill-rule="evenodd"
      ><path d="M0 0h24v24H0z" /><path d="M0 24h24V0H0z" /><path
        fill="currentColor"
        fill-rule="nonzero"
        d="M5 4H3v5a8 8 0 0 0 8 8h7.172l-3.536 3.536 1.414 1.414L22 16l-5.95-5.95-1.414 1.414L18.172 15H11a6 6 0 0 1-6-6z"
      /></g
    ></symbol
  ><symbol id="slate-editor-ArrowDownS" viewBox="0 0 24 24"
    ><path d="m12 13.171 4.95-4.95 1.414 1.415L12 16 5.636 9.636 7.05 8.222z" /></symbol
  ><symbol id="slate-editor-Bold" viewBox="0 0 24 24"
    ><path
      d="M8 11h4.5a2.5 2.5 0 0 0 0-5H8zm10 4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5 0 0 1 3.256 7.606A4.5 4.5 0 0 1 18 15.5M8 13v5h5.5a2.5 2.5 0 0 0 0-5z"
    /></symbol
  ><symbol id="slate-editor-Delete" viewBox="0 0 24 24"
    ><path
      d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm1 2H6v12h12zm-9 3h2v6H9zm4 0h2v6h-2zM9 4v2h6V4z"
    /></symbol
  ><symbol id="slate-editor-Draggable" viewBox="0 0 24 24"
    ><path
      d="M8.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    /></symbol
  ><symbol id="slate-editor-Emoji" viewBox="0 0 20 20"
    ><g fill="none" fill-rule="evenodd"
      ><path d="M0 0h20v20H0z" /><path
        fill="currentColor"
        fill-rule="nonzero"
        d="M10 18.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 0 1 0 16.666m0-1.666a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334m-3.333-5.834h6.666a3.333 3.333 0 0 1-6.666 0m0-1.666a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m6.666 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
      /></g
    ></symbol
  ><symbol id="slate-editor-Emphasis" viewBox="0 0 24 24"
    ><path
      d="M12 19a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-5.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M18 3v2H8v4h9v2H8v4h10v2H6V3z"
    /></symbol
  ><symbol id="slate-editor-FileCopyFill" viewBox="0 0 24 24"
    ><path
      d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1 1 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1zm2 0h8v10h2V4H9z"
    /></symbol
  ><symbol id="slate-editor-FileCopyLine" viewBox="0 0 24 24"
    ><path
      d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1 1 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1zM5.002 8 5 20h10V8zM9 6h8v10h2V4H9z"
    /></symbol
  ><symbol id="slate-editor-FormatClear" viewBox="0 0 24 24"
    ><path
      d="M12.651 14.065 11.605 20H9.574l1.35-7.661-7.41-7.41L4.93 3.515 20.485 19.07l-1.414 1.414zm-.878-6.535.27-1.53h-1.8l-2-2H20v2h-5.927L13.5 9.257z"
    /></symbol
  ><symbol id="slate-editor-Italic" viewBox="0 0 24 24"
    ><path d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z" /></symbol
  ><symbol id="slate-editor-Link" viewBox="0 0 24 24"
    ><path
      d="M18.364 15.536 16.95 14.12l1.414-1.414a5 5 0 0 0-7.071-7.071L9.878 7.05 8.464 5.636l1.414-1.414a7 7 0 0 1 9.9 9.9zm-2.829 2.828-1.414 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 0 0 7.07 7.071l1.415-1.414zm-.707-10.607 1.415 1.415-7.072 7.07-1.414-1.414z"
    /></symbol
  ><symbol id="slate-editor-ListOrdered" viewBox="0 0 24 24"
    ><path
      d="M8 4h13v2H8zM5 3v3h1v1H3V6h1V4H3V3zM3 14v-2.5h2V11H3v-1h3v2.5H4v.5h2v1zm2 5.5H3v-1h2V18H3v-1h3v4H3v-1h2zM8 11h13v2H8zm0 7h13v2H8z"
    /></symbol
  ><symbol id="slate-editor-ListUnordered" viewBox="0 0 24 24"
    ><path
      d="M8 4h13v2H8zM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M8 11h13v2H8zm0 7h13v2H8z"
    /></symbol
  ><symbol id="slate-editor-More2" viewBox="0 0 24 24"
    ><path
      d="M12 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
    /></symbol
  ><symbol id="slate-editor-Paragraph" viewBox="0 0 24 24"
    ><path d="M12 6v15h-2v-5a6 6 0 0 1 0-12h10v2h-3v15h-2V6zm-2 0a4 4 0 1 0 0 8z" /></symbol
  ><symbol id="slate-editor-ScissorsFill" viewBox="0 0 24 24"
    ><path
      d="M9.683 7.559 12 9.875l6.374-6.374a2 2 0 0 1 2.829 0l.707.707L9.683 16.435a4 4 0 1 1-2.121-2.121l2.317-2.317L7.562 9.68A4 4 0 1 1 9.683 7.56M6 7.997a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m9.535-6.587 6.375 6.375-.707.707a2 2 0 0 1-2.829 0l-4.96-4.96z"
    /></symbol
  ><symbol id="slate-editor-Strikethrough" viewBox="0 0 24 24"
    ><path
      d="M17.154 14q.346.774.346 1.72 0 2.014-1.571 3.147Q14.357 20 11.586 20q-2.46 0-4.87-1.145v-2.254q2.28 1.316 4.666 1.316 3.826 0 3.839-2.197a2.2 2.2 0 0 0-.648-1.603l-.12-.117H3v-2h18v2zm-4.078-3H7.629a4 4 0 0 1-.481-.522Q6.5 9.643 6.5 8.452q0-1.854 1.397-3.153T12.222 4q2.207 0 4.222.984v2.152q-1.8-1.03-3.946-1.03-3.72 0-3.719 2.346 0 .63.654 1.099.654.47 1.613.75.93.27 2.03.699"
    /></symbol
  ><symbol id="slate-editor-Subscript" viewBox="0 0 24 24"
    ><path
      d="M5.596 4 10.5 9.928 15.404 4H18l-6.202 7.497L18 18.994V19h-2.59l-4.91-5.934L5.59 19H3v-.006l6.202-7.497L3 4zM21.8 16a.8.8 0 1 0-1.57.22l-1.154.33A2.001 2.001 0 1 1 23 16c0 .573-.24 1.09-.626 1.454L20.744 19H23v1h-4v-1l2.55-2.42a.8.8 0 0 0 .25-.58"
    /></symbol
  ><symbol id="slate-editor-Superscript" viewBox="0 0 24 24"
    ><path
      d="m5.596 5 4.904 5.928L15.404 5H18l-6.202 7.497L18 19.994V20h-2.59l-4.91-5.934L5.59 20H3v-.006l6.202-7.497L3 5zM21.55 6.58a.8.8 0 1 0-1.32-.36l-1.155.33A2.001 2.001 0 1 1 23 6c0 .573-.24 1.09-.626 1.454L20.744 9H23v1h-4V9z"
    /></symbol
  ><symbol id="slate-editor-Underline" viewBox="0 0 24 24"
    ><path d="M8 3v9a4 4 0 0 0 8 0V3h2v9a6 6 0 0 1-12 0V3zM4 20h16v2H4z" /></symbol
  ><symbol id="sparkling-2-line" viewBox="0 0 24 24"
    ><path
      d="m17 1.208 1.32 2.473L20.792 5 18.32 6.319 17 8.792l-1.318-2.473-2.473-1.32 2.473-1.318zm-6.333 8.125 5 2.667-5 2.667-2.666 5-2.667-5-5-2.667 5-2.667 2.667-5zm.75 2.667L9.19 10.812 8.001 8.583l-1.189 2.229L4.584 12l2.228 1.188 1.189 2.229 1.188-2.229zm8.25 4.333-1.666-3.125-1.667 3.125L13.209 18l3.125 1.667 1.667 3.125 1.666-3.125L22.792 18z"
    /></symbol
  ><symbol id="speed-up-line" viewBox="0 0 24 24"
    ><path
      d="M20 13c0 2.21-.895 4.21-2.343 5.657l1.414 1.414A9.97 9.97 0 0 0 22 13c0-5.523-4.477-10-10-10S2 7.477 2 13a9.97 9.97 0 0 0 2.929 7.071l1.414-1.414A8 8 0 1 1 20 13m-4.707-4.707-4.5 4.5 1.414 1.414 4.5-4.5z"
    /></symbol
  ><symbol id="star-filled" viewBox="0 0 21.415 19.897"
    ><path
      fill="#FFD07C"
      stroke="#FFD07C"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M9.807 1.559a1 1 0 0 1 1.795 0l2.163 4.4a1 1 0 0 0 .778.552l4.969.6a1 1 0 0 1 .548 1.737l-3.591 3.22a1 1 0 0 0-.313.941l.934 4.667a1 1 0 0 1-1.446 1.081l-4.474-2.355a1 1 0 0 0-.931 0l-4.472 2.353a1 1 0 0 1-1.446-1.081l.934-4.667a1 1 0 0 0-.313-.941l-3.591-3.22a1 1 0 0 1 .548-1.737l4.969-.6a1 1 0 0 0 .778-.552Z"
    /></symbol
  ><symbol id="star-light" viewBox="0 0 60.001 57.237"
    ><path
      fill="#515b60"
      d="M59.913 21.733a1.76 1.76 0 0 0-1.438-1.2l-9.286-1.284h-.087L39.81 17.96 31.588 1a1.764 1.764 0 0 0-3.176 0l-8.221 16.954-18.668 2.58a1.765 1.765 0 0 0-.982 3.021L14.13 36.611l-3.317 18.551a1.765 1.765 0 0 0 2.57 1.866L30 48.141l16.618 8.888a1.763 1.763 0 0 0 2.568-1.866L45.87 36.611l13.589-13.058a1.77 1.77 0 0 0 .454-1.82m-17.17 12.989a1.76 1.76 0 0 0-.515 1.584L45.072 52.2l-14.24-7.617a1.77 1.77 0 0 0-1.665 0L14.928 52.2l2.842-15.9a1.76 1.76 0 0 0-.514-1.584L5.612 23.529l16-2.209a1.76 1.76 0 0 0 1.346-.977L30 5.812l7.035 14.511a1.76 1.76 0 0 0 1.355 1l13.239 1.828.007-.006 2.752.38Z"
    /></symbol
  ><symbol id="star" viewBox="0 0 21.415 19.897"
    ><path
      fill="none"
      stroke="#3b4d6a"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M9.807 1.559a1 1 0 0 1 1.795 0l2.163 4.4a1 1 0 0 0 .778.552l4.969.6a1 1 0 0 1 .548 1.737l-3.591 3.22a1 1 0 0 0-.313.941l.934 4.667a1 1 0 0 1-1.446 1.081l-4.474-2.355a1 1 0 0 0-.931 0l-4.472 2.353a1 1 0 0 1-1.446-1.081l.934-4.667a1 1 0 0 0-.313-.941l-3.591-3.22a1 1 0 0 1 .548-1.737l4.969-.6a1 1 0 0 0 .778-.552Z"
    /></symbol
  ><symbol id="stop-fill" viewBox="0 0 24 24"
    ><path d="M6 5h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1" /></symbol
  ><symbol id="text" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0z" /><path
      d="M3 3h18v2H3Zm0 15h14v2H3Zm0-5h18v2H3Zm0-5h14v2H3Z"
    /></symbol
  ><symbol id="theory" viewBox="0 0 26.667 26.667"
    ><path
      fill="currentColor"
      d="M13.333 26.667a13.333 13.333 0 1 1 13.334-13.334 13.333 13.333 0 0 1-13.334 13.334m0-2.667A10.667 10.667 0 1 0 2.667 13.333 10.667 10.667 0 0 0 13.333 24M12 6.667h2.667v2.667H12ZM12 12h2.667v8H12Z"
    /></symbol
  ><symbol id="toggle-active" viewBox="0 0 24 24"
    ><g fill="none" fill-rule="evenodd"
      ><path d="M0 0h24v24H0z" /><path d="M0 0h24v24H0z" /><path
        fill="currentColor"
        fill-rule="nonzero"
        d="M8 5h8a7 7 0 0 1 0 14H8A7 7 0 1 1 8 5m8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
      /></g
    ></symbol
  ><symbol id="toggle" viewBox="0 0 24 24"
    ><g fill="none" fill-rule="evenodd"
      ><path d="M0 0h24v24H0z" /><path d="M0 0h24v24H0z" /><path
        fill="currentColor"
        fill-rule="nonzero"
        d="M8 7a5 5 0 1 0 0 10h8a5 5 0 0 0 0-10zm0-2h8a7 7 0 0 1 0 14H8A7 7 0 1 1 8 5m0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
      /></g
    ></symbol
  ><symbol id="trash" viewBox="0 0 20 20"
    ><path fill="none" d="M0 0h20v20H0z" /><path
      fill="currentColor"
      d="M5.83 18.33a1.67 1.67 0 0 1-1.66-1.66V5h-.84V3.33h2.09l2.5-2.5h4.16l2.5 2.5h2.09V5h-.84v11.67a1.67 1.67 0 0 1-1.66 1.66zm0-1.66h8.34V5H5.83zm6.25-13.34-.83-.83h-2.5l-.83.83zM10.83 15V6.67h1.67V15zM7.5 15V6.67h1.67V15z"
    /></symbol
  ><symbol id="u-underline" viewBox="0 0 24 24"
    ><text
      fill="#3b4d6a"
      font-family="Roboto-Regular, Roboto"
      font-size="18"
      text-decoration="underline"
      transform="translate(6 19)"
    >
      <tspan x="0" y="0">U</tspan>
    </text><path fill="none" d="M0 0h24v24H0z" /></symbol
  ><symbol id="unpublished" viewBox="0 0 24.003 24"
    ><g
      ><circle cx="12" cy="12" r="12" fill="#fff" /><path
        fill="#3b4d6a"
        d="M12.004 24a12 12 0 1 1 8.486-3.515A12 12 0 0 1 12.004 24"
      /></g
    ><g fill="#fff"
      ><path d="m14.607 8.54 1.334 1.334-6.615 6.615-1.333-1.334z" /><path
        d="m15.94 15.157-1.21 1.21-6.615-6.613 1.211-1.212z"
      /></g
    ></symbol
  ><symbol id="user-add" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m6 6v-3h2v3h3v2h-3v3h-2v-3h-3v-2z"
    /></symbol
  ><symbol id="user" viewBox="0 0 20 20"
    ><path fill="none" d="M0 0h20v20H0Z" /><path
      d="M10 2a8 8 0 1 0 8 8 8 8 0 0 0-8-8M6.06 15.02C6.4 14.3 8.5 13.6 10 13.6s3.6.7 3.94 1.42a6.34 6.34 0 0 1-7.88 0m9.03-1.16C13.94 12.47 11.17 12 10 12s-3.94.47-5.09 1.86a6.4 6.4 0 1 1 10.18 0M10 5.2A2.8 2.8 0 1 0 12.8 8 2.8 2.8 0 0 0 10 5.2m0 4A1.2 1.2 0 1 1 11.2 8 1.2 1.2 0 0 1 10 9.2"
    /></symbol
  ><symbol id="video" viewBox="0 0 24 24"
    ><path fill="none" d="M0 0h24v24H0Z" /><path
      d="M2 3.993A1 1 0 0 1 2.992 3h18.016a.993.993 0 0 1 .992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007ZM4 5v14h16V5Zm6.622 3.415 4.878 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.62-.332V8.747a.4.4 0 0 1 .622-.332"
    /></symbol
  ><symbol id="vimeo" viewBox="0 0 36.04 36"><path fill="url(#a)" d="M0 0h36.04v36H0z" /></symbol
  ><symbol id="volume-up-fill" viewBox="0 0 24 24"
    ><path
      d="M2 16h3.889l5.294 4.332a.5.5 0 0 0 .817-.387V4.055a.5.5 0 0 0-.817-.387L5.89 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m21-4c0 3.292-1.446 6.246-3.738 8.262l-1.418-1.418A8.98 8.98 0 0 0 21 12a8.98 8.98 0 0 0-3.155-6.844l1.417-1.418A10.97 10.97 0 0 1 23 12m-5 0a5.99 5.99 0 0 0-2.287-4.713l-1.429 1.429A4 4 0 0 1 16 12c0 1.36-.679 2.561-1.716 3.284l1.43 1.43A5.99 5.99 0 0 0 18 12"
    /></symbol
  ><symbol id="zebis-logo-without-claim" viewBox="0 0 612.24 231.42"
    ><path
      d="M6.42 228.21A6.54 6.54 0 0 1 0 221.79v-6.67a24.6 24.6 0 0 1 3.46-11.87l54.86-81.54H11.86a6.54 6.54 0 0 1-6.42-6.43v-4.45a6.53 6.53 0 0 1 6.42-6.42h62a6.53 6.53 0 0 1 6.42 6.42v6.43a24.53 24.53 0 0 1-3.46 11.86l-54.33 81.79h53.37a6.55 6.55 0 0 1 6.43 6.43v4.45a6.54 6.54 0 0 1-6.43 6.42ZM153.21 231.42c-32.37 0-50.66-18.78-50.66-65.23 0-47 19.27-65 48.43-65 29.41 0 46.21 16.81 46.21 61.54v4.44a3.9 3.9 0 0 1-3.95 4h-68c.5 33.85 7.91 42.26 28.42 42.26 10.63 0 17.55-3.22 24-7.66a6.58 6.58 0 0 1 9.15 1.23l4 5.19a6.37 6.37 0 0 1-1.48 8.9c-10.17 7.12-20.55 10.33-36.12 10.33M150.49 118c-14.33 0-23.23 7.41-25 37.06h49.18c.04-28.41-6.39-37.06-24.18-37.06M281.7 231.42c-13.59 0-26.93-6.92-34.1-15.07l-1.73 5.65a8.45 8.45 0 0 1-8.15 6.18H234a6.54 6.54 0 0 1-6.43-6.42V55.72A6.55 6.55 0 0 1 234 49.3h8.4a6.55 6.55 0 0 1 6.43 6.42v61.54c8.89-9.39 20-16.07 33.11-16.07 23.72 0 42.26 13.35 42.26 64.25.01 46.46-13.58 65.98-42.5 65.98m-5.43-18.28c17.54 0 25.2-6.43 25.2-46.21s-6.42-47.45-23.23-47.45c-12.1 0-20.51 6.18-29.4 14.58v67c7.16 6.94 17.05 12.08 27.43 12.08M369.43 228.21a6.54 6.54 0 0 1-6.43-6.42V121l-11.86-2a7.47 7.47 0 0 1-6.43-7.42v-.74a6.54 6.54 0 0 1 6.43-6.42h26.69a6.53 6.53 0 0 1 6.42 6.42v111a6.53 6.53 0 0 1-6.42 6.42Zm3.7-146.79c-8.4 0-14.58-6.67-14.58-15.07C358.55 57.7 365 51 373.38 51c8.65 0 15.07 6.43 15.07 15.32a14.88 14.88 0 0 1-15.32 15.1M452.21 231.42a75.34 75.34 0 0 1-35.84-9.63 6.75 6.75 0 0 1-2.22-8.9l2.72-4.69a6.24 6.24 0 0 1 8.65-2.47c8.65 4.94 17.54 7.9 27.67 7.9 16.81 0 22-6.67 22-18.28 0-13.84-6.43-16.56-26.2-22-17.29-4.69-31.63-13.84-31.63-38.3 0-18 11.62-33.86 38.8-33.86 11.86 0 20.76 2 28.66 5.19A6.61 6.61 0 0 1 488 115l-2.19 5a6.62 6.62 0 0 1-8.65 3.46 45.3 45.3 0 0 0-20.26-4.2c-13.34 0-19.52 4.7-19.52 15.32 0 11.62 5.19 14.58 22.24 19.28 19 5.19 36.33 12.6 36.33 40.53.05 25.67-14.58 37.03-43.74 37.03M513.19 103.07a4.88 4.88 0 0 1-3.44-8.33l39.14-39h-19.65a4.88 4.88 0 1 1 0-9.75h31.42a5.1 5.1 0 0 1 1.8.34l.2.08a4.8 4.8 0 0 1 1.88 1.48 6 6 0 0 1 .32.47 4.9 4.9 0 0 1 .69 2.47v31.52a4.89 4.89 0 0 1-4.88 4.88 4.88 4.88 0 0 1-4.87-4.88V62.63l-39.19 39a4.84 4.84 0 0 1-3.42 1.44"
      class="cls-1"
    /><path
      d="M558.24 108.14a54.1 54.1 0 0 1-24.75-6 4.87 4.87 0 1 1 4.51-8.68 44.33 44.33 0 1 0-19.16-19.17 4.87 4.87 0 1 1-8.67 4.46 54 54 0 1 1 48.12 29.39Z"
      class="cls-1"
    /></symbol
  ></svg
>
